var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.signStatus
    ? _c("div", [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShow,
              expression: "isShow",
            },
          ],
          staticClass: "mask",
        }),
        _c("div", { staticClass: "pdf el-message specification" }, [
          _c("div", { staticClass: "agreement_top" }, [
            _vm.successUrl !== ""
              ? _c("i", {
                  staticClass: "el-icon-close",
                  on: { click: _vm.handleCloseSign },
                })
              : _vm._e(),
            _c("div", { staticClass: "agreement_tit" }, [
              _vm._v(_vm._s(_vm.pageInfo.protocolName)),
            ]),
            _c("div", { staticClass: "agreement_tips" }, [
              _vm._v(
                " 为加强公司内容运营及规范管理流程，请仔细阅读并完成签署以便继续使用伏羲云系统，感谢您的理解与支持。 "
              ),
            ]),
          ]),
          _vm.successUrl === ""
            ? _c(
                "div",
                {
                  staticClass: "show overflowOuto overflowOutoStop",
                  on: { scroll: _vm.scrollEvent },
                },
                [
                  _vm.pageInfo.protocolUrl
                    ? _c("iframe", {
                        attrs: {
                          src: _vm.pageInfo.protocolUrl,
                          width: "100%",
                          height: "100%",
                          frameborder: "0",
                        },
                      })
                    : _c("div", [_vm._v("加载中...")]),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "show overflowOuto overflowOutoStop",
                  on: { scroll: _vm.scrollEvent },
                },
                [
                  _vm.successUrl
                    ? _c("iframe", {
                        attrs: {
                          src: _vm.successUrl,
                          width: "100%",
                          height: "100%",
                          frameborder: "0",
                        },
                      })
                    : _c("div", [_vm._v("加载中...")]),
                ]
              ),
          _vm.successUrl === ""
            ? _c(
                "div",
                { staticClass: "sign" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: _vm.isReadOver ? "primary" : "",
                        disabled: !_vm.isReadOver,
                        size: "mini",
                      },
                      on: { click: _vm.sign },
                    },
                    [
                      _vm._v(
                        " 立即签署 " +
                          _vm._s(
                            _vm.pageInfo.protocolUrl && _vm.number
                              ? _vm.number + "s"
                              : ""
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.successUrl !== ""
            ? _c(
                "div",
                { staticClass: "download" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.downloadPdf },
                    },
                    [_vm._v("下载签署文件")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }